//# sourceMappingURL=scroll.mjs.map
/// <reference types="./scroll.d.mts" />
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $context from "../../../redraw_unsafe/redraw/unsafe/context.mjs";
import { Ok, CustomType as $CustomType, makeError } from "../../gleam.mjs";

const FILEPATH = "src/ds/providers/scroll.gleam";

export class Scroll extends $CustomType {
  constructor(scrollable, overflow, freeze, unfreeze) {
    super();
    this.scrollable = scrollable;
    this.overflow = overflow;
    this.freeze = freeze;
    this.unfreeze = unfreeze;
  }
}
export const Scroll$Scroll = (scrollable, overflow, freeze, unfreeze) =>
  new Scroll(scrollable, overflow, freeze, unfreeze);
export const Scroll$isScroll = (value) => value instanceof Scroll;
export const Scroll$Scroll$scrollable = (value) => value.scrollable;
export const Scroll$Scroll$0 = (value) => value.scrollable;
export const Scroll$Scroll$overflow = (value) => value.overflow;
export const Scroll$Scroll$1 = (value) => value.overflow;
export const Scroll$Scroll$freeze = (value) => value.freeze;
export const Scroll$Scroll$2 = (value) => value.freeze;
export const Scroll$Scroll$unfreeze = (value) => value.unfreeze;
export const Scroll$Scroll$3 = (value) => value.unfreeze;

const context_name = "Freyja:Providers:Scroll";

function use_overflow_auto(scrollable) {
  let hidden = $redraw.use_memo(() => { return "hidden"; }, []);
  let auto_ = $redraw.use_memo(() => { return "auto"; }, []);
  return ((_capture) => { return $redraw.use_memo(_capture, [scrollable]); })(
    () => {
      if (scrollable) {
        return auto_;
      } else {
        return hidden;
      }
    },
  );
}

function use_scrollable_context() {
  let $ = $redraw.use_state(true);
  let scrollable = $[0];
  let set_scrollable = $[1];
  let freeze = $redraw.use_callback(() => { return set_scrollable(false); }, []);
  let unfreeze = $redraw.use_callback(
    () => { return set_scrollable(true); },
    [],
  );
  let overflow = use_overflow_auto(scrollable);
  return ((_capture) => { return $redraw.use_memo(_capture, [scrollable]); })(
    () => { return new Scroll(scrollable, overflow, freeze, unfreeze); },
  );
}

function default_value() {
  return new Scroll(
    true,
    "auto",
    () => { return undefined; },
    () => { return undefined; },
  );
}

export function provider() {
  let context = $context.context(context_name, default_value);
  return $redraw.component_(
    "Freyja.Providers(Scroll)",
    (children) => {
      let scrollable = use_scrollable_context();
      return $redraw.provider(context, scrollable, children);
    },
  );
}

/**
 * Read the scroll context, to indicate whether the application is frozen or
 * not. Can be used to freeze or unfreeze the application.
 */
export function use_scroll() {
  let $ = $context.get(context_name);
  let context;
  if ($ instanceof Ok) {
    context = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "ds/providers/scroll",
      25,
      "use_scroll",
      "Pattern match failed, no pattern matched the value.",
      { value: $, start: 636, end: 686, pattern_start: 647, pattern_end: 658 }
    )
  }
  return $redraw.use_context(context);
}

/**
 * Read the scroll context, and get back the overflow. It avoid to constantly
 * read the scroll context, and then read the overflow value.
 */
export function use_overflow() {
  let scroll = use_scroll();
  return ((_capture) => { return $redraw.use_memo(_capture, [scroll]); })(
    () => { return scroll.overflow; },
  );
}

/**
 * Read the scroll context, and get back the scrollable. It avoid to constantly
 * read the scroll context, and then read the scrollable value.
 */
export function use_scrollable() {
  let scroll = use_scroll();
  return scroll.scrollable;
}

/**
 * Automatically freeze or unfreeze the DOM, according to the value of
 * `frozen`. If `frozen` is `True`, freeze the DOM, and unfreeze the DOM on
 * unmount. If `frozen` is `False`, the DOM will not be frozen at all.
 */
export function use_freeze(frozen) {
  let scroll = use_scroll();
  return ((_capture) => {
    return $redraw.use_effect_(_capture, [scroll, frozen]);
  })(
    () => {
      if (frozen) {
        scroll.freeze();
      } else {
        scroll.unfreeze();
      }
      return () => { return scroll.unfreeze(); };
    },
  );
}
